export function generateAddress(number, street, city, postalCode, country) {
  if (!number && !street && !city && !postalCode && !country) {
    return "/";
  } else {
    return `${number ?? ""} ${street ?? ""}${number && street ? "," : ""} ${postalCode ?? ""} ${city ?? ""}${
      postalCode && city && country ? "," : ""
    } ${country ?? ""}`;
  }
}
